import DriverAppReleasesApi from "../../services/api/DriverAppReleases";

export const getDriverReleasedList = async (filters = {}, pageRequest = {}) => {
  let finalPayload = {
    filters: {},
    page_request: { page: 1 },
  };
  const response = await DriverAppReleasesApi.getAppReleasesList(finalPayload);
  const releasedApp = response["releases"];
  const releasedAppList = [];
  let i = 0;
  while (i < releasedApp.length) {
    releasedAppList.push({ id: i + 1, name: releasedApp[i]["version"] });
    i++;
  }
  return new Promise((res) => {
    res({
      releasedAppVersions: releasedAppList,
    });
  });
};
